<div>
  <mat-card appearance="outlined" class="main-info">
    <mat-card-content noDataTableMessage [dataSource]="notifications">
      <ng-container *ngIf="notifications?.length">
        <div *ngFor="let notification of notifications" class="notification">
          <span class="notification__date">
            <ng-container *ngIf="!isLocalDate; else localDate">
              {{ notification?.actualArrivalTime | locale }}
            </ng-container>
            <ng-template #localDate>
              <ng-container *ngIf="displayLocalAndProfileTime; else simpleReceivedTimeDate">
                <ui-date-with-profile-and-local-timezone
                  [timestamp]="getDateWithTimezones(notification)?.timestamp"
                  [localTimezoneData]="getDateWithTimezones(notification)?.localTimezoneData"
                  [profileTimezoneData]="getDateWithTimezones(notification)?.profileTimezoneData"
                  class="tw-overflow-hidden tw-text-ellipsis"
                ></ui-date-with-profile-and-local-timezone>
              </ng-container>
              <ng-template #simpleReceivedTimeDate>
                <ui-date-with-timezone
                  [localDate]="getLocalDate(notification)"
                  [isAligningApplicable]="true"
                ></ui-date-with-timezone>
              </ng-template>
            </ng-template>
          </span>
          <span class="notification__description" cropText>
            {{ notification?.reason }}
          </span>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
